export enum Permission {
  // Admin-only access (for development/testing before retailer permissions are ready)
  Admin = 'admin_panel.legacy_permission',

  // Future retailer permissions (will be uncommented when backend permissions are created)
  RecipesV2View = 'recipes_v2.view',
  RecipesV2Modify = 'recipes_v2.modify',
}
